import styled from "styled-components";

const ShoppingListContainerButtons = styled.div`
  display: flex;
  justify-content: space-evenly;
  @media (min-width: 769px) {
    margin: auto;
    max-width: 400px;
  }
`;

export default ShoppingListContainerButtons;
